import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import GeneratorToolCard from '../components/GeneratorToolCard.vue'
import {
  mockSalesPoint,
  SalesPointsService,
  MunicipalEntitiesService,
  Context,
  throwObjectNotFound,
} from '@prodcard/core'
import { GeneratorTool, getRandomFromRepo } from '../components/model'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesPointsTool',
  props: {
    salesPointsService: {},
    municipalEntitiesService: {}
  },
  setup(__props: any) {

const props = __props;



async function getRandomMEId(ctx: Context) {
  return (
    (await getRandomFromRepo(paging => props.municipalEntitiesService.findAll(ctx, { paging })))?.id ??
    throwObjectNotFound('<b0a200c7>')
  )
}

function getRandomSP(ctx: Context) {
  return getRandomFromRepo(paging => props.salesPointsService.findAll(ctx, { paging }))
}

const generatorTool: GeneratorTool = {
  create: async (ctx: Context) => {
    const salesPoint = mockSalesPoint()
    await props.salesPointsService.add(ctx, {
      ...salesPoint,
      municipalEntityId: await getRandomMEId(ctx),
    })
  },
  update: async (ctx: Context) => {
    const sp = await getRandomSP(ctx)
    if (!sp) return
    const salesPoint = mockSalesPoint()
    await props.salesPointsService.update(ctx, sp.id, {
      ...salesPoint,
      municipalEntityId: await getRandomMEId(ctx),
    })
  },
  delete: async (ctx: Context) => {
    const sp = await getRandomSP(ctx)
    if (!sp) return
    await props.salesPointsService.delete(ctx, sp.id)
  },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneratorToolCard, {
    title: "Действия с торговыми объектами",
    "generator-tool": generatorTool
  }))
}
}

})